module.exports = __webpack_public_path__ + "static/media/why_carwiser_banner_mobile.8980461d.png";